import {CalComLayout} from '@/Types/Meetings/CalComLayout'

const pushIntoQProperty = (a, ar):void => {
	a.q.push(ar)
}

export const initCalCom = (namespace:string, elementId:string, layout:CalComLayout):void => {
	window.Cal = window.Cal || {}

	if(!window.Cal.loaded){
		window.Cal.ns = {}
		window.Cal.q = []
		document.head.appendChild(document.createElement("script")).src = "https://app.cal.com/embed/embed.js"
		window.Cal.loaded = true
	}

	const api = function():void{
		pushIntoQProperty(api, [namespace])
	}

	api.q = []
	window.Cal.ns[namespace] = window.Cal.ns[namespace] || api
	pushIntoQProperty(window.Cal.ns[namespace], [namespace, elementId])
	pushIntoQProperty(window.Cal, [
		'initNamespace',
		namespace,
	])
	pushIntoQProperty(window.Cal, [
		'inline',
		{
			elementOrSelector: `#${elementId}`,
			config: {
				layout: layout,
			},
			calLink: `aareii-sysadmin/${namespace}`,
		},
	])
	pushIntoQProperty(window.Cal, [
		'ui',
		{
			cssVarsPerTheme: {
				light: {
					'cal-brand': '#1469a1'
				},
				dark: {
					'cal-brand': '#1469a1'
				}
			},
			hideEventTypeDetails: false,
			layout: layout,
		},
	])
}